<template>
  <div>
    <home-banner
      title="档案管理新闻"
      description="由纸质档案向电子化档案转型的必选工具。"
    />
    <infolist></infolist>
  </div>
</template>
  
  <script>
import homeBanner from "./components/homeBanner.vue";
import infolist from "./components/infolist.vue";
export default {
  components: {
    homeBanner,
    infolist
  },
  data() {
    return {};
  },
};
</script>
  
<style lang="scss" scoped>
</style>